import React from 'react';
import { Carousel } from 'react-bootstrap';

const Banner = () => {
    return (
        <div>
            <Carousel className='banner-bg'>
                <Carousel.Item>
                    <img className='w-100' src="https://i.ibb.co/ZK0FKxp/Amer-Bari-Cover-01.jpg" alt="" />
                </Carousel.Item>
                <Carousel.Item>
                    <div style={{padding: '250px 0' }}>
                        <div className="container">
                            <div className="d-flex align-items-center">
                                <div>
                                    <h1 className="text-white">রাজশাহীর আমের বিশাল সমাহার</h1>
                                    <p className="text-white">রাজশাহী এবং চাপাই নবাব গঞ্জের ক্যামিক্যাল মুক্ত সম্পূর্ণ অরগানিক আম সারা দেশে ডেলিভারী দিয়ে থাকে আমের বাড়ি । ভেজাল মুক্ত খাঁটি আম পেতে অর্ডার করুন</p>
                                </div>
                                <div>
                                    <img className="w-100" src="https://rajajinationalpark.org/wp-content/uploads/jangli-aam-1.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div style={{padding: '250px 0' }}>
                        <div className="container">
                            <div className="d-flex align-items-center">
                                <div>
                                    <h1 className="text-white">রাজশাহীর আমের বিশাল সমাহার</h1>
                                    <p className="text-white">রাজশাহী এবং চাপাই নবাব গঞ্জের ক্যামিক্যাল মুক্ত সম্পূর্ণ অরগানিক আম সারা দেশে ডেলিভারী দিয়ে থাকে আমের বাড়ি । ভেজাল মুক্ত খাঁটি আম পেতে অর্ডার করুন</p>
                                </div>
                                <div>
                                    <img className="w-100" src="http://uppercrustindia.com/2019/media/postassets/2019/Sep/10/image-20190910105652-1_0.jpeg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div style={{padding: '250px 0' }}>
                        <div className="container">
                            <div className="d-flex align-items-center">
                                <div>
                                    <h1 className="text-white">রাজশাহীর আমের বিশাল সমাহার</h1>
                                    <p className="text-white">রাজশাহী এবং চাপাই নবাব গঞ্জের ক্যামিক্যাল মুক্ত সম্পূর্ণ অরগানিক আম সারা দেশে ডেলিভারী দিয়ে থাকে আমের বাড়ি । ভেজাল মুক্ত খাঁটি আম পেতে অর্ডার করুন</p>
                                </div>
                                <div>
                                    <img className="w-100" src="https://cdn.shopify.com/s/files/1/0305/2968/3595/products/plantnurseryonline-mango-kesar-aam-kesar-grafted_800x.jpg?v=1578437405" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel.Item>
            </Carousel>
        </div>
    );
};

export default Banner;